export default __webpack_public_path__ + "static/media/default_profile_image.022d57c1.svg";